import { BitkitLabel, BitkitNativeSelect } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Card } from '@chakra-ui/react/card';

import Chart, { ChartType } from '@/pages/Insights/components/Chart/Chart';
import { ChartDataEntity, TypeMetricUnit } from '@/pages/Insights/Insights.types';

type ResourceChartProps = {
  title: string;
  data?: ChartDataEntity[];
  dataUnit: TypeMetricUnit;
  type: ChartType;
  threshold?: number;
  tooltipText?: string;
  placeholder?: string;
  options?: string[];
  isLoading: boolean;
  error?: any;
  isError?: boolean;
  selectValue?: string;
  onSelectChange?: (value: string) => void;
  refetch: () => void;
  chartStart?: number;
  chartEnd?: number;
  withZoom?: boolean;
};

const ResourceChart = (props: ResourceChartProps) => {
  const {
    chartStart,
    chartEnd,
    data,
    dataUnit,
    error,
    isError,
    isLoading,
    onSelectChange,
    options = [],
    placeholder,
    refetch,
    selectValue,
    title,
    type,
    threshold,
    tooltipText,
    withZoom = true,
  } = props;

  return (
    <Card.Root asChild>
      <Card.Body>
        <Box display="flex" justifyContent="space-between" mb="16">
          <BitkitLabel as="h4" textStyle="heading/h4" tooltip={tooltipText}>
            {title}
          </BitkitLabel>
          {!!onSelectChange && (
            <BitkitNativeSelect
              optional
              labelHidden
              label={title}
              placeholder={placeholder}
              size="md"
              state={isLoading ? 'loading' : options.length === 0 ? 'disabled' : undefined}
              value={selectValue}
              onChange={(e) => onSelectChange?.(e.target.value)}
              maxWidth="50%"
            >
              {options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </BitkitNativeSelect>
          )}
        </Box>
        <Chart
          data={data}
          dataUnit={dataUnit}
          error={error}
          isError={!!isError}
          isLoading={isLoading}
          showEmptyHelp={false}
          height={300}
          isMultiline
          refetch={refetch}
          showLegend
          syncId={title.toLowerCase()}
          type={type}
          widgetId={`resources_${title.toLowerCase()}`}
          chartStart={chartStart}
          chartEnd={chartEnd}
          threshold={threshold}
          interval="secondly"
          withZoom={withZoom}
        />
      </Card.Body>
    </Card.Root>
  );
};

export default ResourceChart;
